class Resources {
    APP_NAME = "応募者管理システム";
    //BACKEND_SIDE_BASE_URL = "http://127.0.0.1:8000/api"; //Use this for local testing.
    BACKEND_SIDE_BASE_URL = "https://leap-shine.link/api";
}
export default Resources;